import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { RouterModule } from '@angular/router';
import { svgIconComponent } from './component/svg-icon/svg-icon.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { WebCamComponent } from './component/web-cam/web-cam.component';
import { WebcamModule } from 'ngx-webcam';
import { DropdownComponent } from './component/dropdown/dropdown.component';
import { ModalComponent } from './component/modal/modal.component';
import { ContainerComponent } from './component/container/container.component';
import { TermsConditionModalComponent } from './component/terms-condition-modal/terms-condition-modal.component';


import { PdfPreviewComponent } from './component/pdf-preview/pdf-preview.component';
import { DocumentEditorModule } from '@onlyoffice/document-editor-angular';
import { CardSkeletonLoaderComponent } from './component/card-skeleton-loader/card-skeleton-loader.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ButtonComponent } from './component/button/button.component';
import { ClickOutsideDirective, YearPickerComponent } from './component/year-picker/year-picker.component';
import { HeaderComponent } from './component/header/header.component';
import { ChangePasswordFormComponent } from './component/popup-forms/change-password-form/change-password-form.component';
import { ShowpopupDirective } from './directives/showpopup.directive';
import { OutsideClickDirective } from './directives/outside-click.directive';
import { ShortNamePipe } from './pipes/short-name.pipe';
import { CustomNumberToWordsPipe } from './pipes/custom-number-to-words.pipe';
import { RemoveDollarSignPipe } from './pipes/remove-dollar-sign.pipe';
import { TrimDecimalPointsPipe } from './pipes/trim-decimal-points.pipe';
import { AppNoSpacesDirective } from './pipes/app-no-spaces.directive';
import { NoF5DirectiveDirective } from './pipes/no-f5-directive.directive';
import { CustomDatePipe } from './pipes/custom-date.pipe';
import { ReplaceNPipe } from './pipes/replace-n.pipe';
import { LoaderComponent } from './component/loader/loader.component';
import { StripHtmlPipe } from './pipes/StripHtmlPipe';
import { ReplaceUnderscorePipe } from './pipes/ReplaceUnderScore.pipe';
import { EscapeHtmlPipe } from './pipes/escapeHtml.pipe';
import { NotFoundComponent } from './component/not-found/not-found.component';
import { TooltipComponent } from './component/tooltip/tooltip.component';
import { SafeLinkPipe } from './pipes/safe-link.pipe';
import { ScreenshotViewerComponent } from './component/screenshot-viewer/screenshot-viewer.component';
import { AudioVideoPermissionComponent } from './component/audio-video-permission/audio-video-permission.component';
import { SuperAdminHeaderComponent } from './component/super-admin-header/super-admin-header.component';
import { CommonPopupComponent } from './component/common-popup/common-popup.component';
import { SecondryButtonComponent } from './component/secondry-button/secondry-button.component';
import { DateTimePickerComponent } from './component/date-time-picker/date-time-picker.component';
import { NoDataFoundComponent } from './component/no-data-found/no-data-found.component';
import { TableSkeletonComponent } from './component/table-skeleton/table-skeleton.component';
import { AudioVideoSetupComponent } from './component/audio-video-setup/audio-video-setup.component';
import { NgOtpInputModule } from 'ng-otp-input';
import { OtpVerifyBoxComponent } from './component/otp-verify-box/otp-verify-box.component';

@NgModule({ declarations: [
        ScreenshotViewerComponent,
        svgIconComponent,
        WebCamComponent,
        DropdownComponent,
        ModalComponent,
        ContainerComponent,
        TermsConditionModalComponent,
        PdfPreviewComponent,
        CardSkeletonLoaderComponent,
        NoDataFoundComponent,
        TableSkeletonComponent,
        ButtonComponent,
        YearPickerComponent,
        ClickOutsideDirective,
        HeaderComponent,
        ChangePasswordFormComponent,
        ShowpopupDirective,
        OutsideClickDirective,
        ShortNamePipe,
        CustomNumberToWordsPipe,
        RemoveDollarSignPipe,
        TrimDecimalPointsPipe,
        ReplaceNPipe,
        RemoveDollarSignPipe,
        StripHtmlPipe,
        AppNoSpacesDirective, NoF5DirectiveDirective, CustomDatePipe, ReplaceNPipe, LoaderComponent,
        ReplaceUnderscorePipe, EscapeHtmlPipe, NotFoundComponent, TooltipComponent, SafeLinkPipe, ScreenshotViewerComponent, AudioVideoPermissionComponent, SuperAdminHeaderComponent, CommonPopupComponent, SecondryButtonComponent, DateTimePickerComponent, AudioVideoSetupComponent, OtpVerifyBoxComponent
    ],
    exports: [
        svgIconComponent, WebCamComponent, TooltipComponent, ScreenshotViewerComponent, CommonPopupComponent, SecondryButtonComponent, DateTimePickerComponent,
        ModalComponent, DropdownComponent, ContainerComponent, TermsConditionModalComponent, YearPickerComponent,
        WebCamComponent, ModalComponent, DropdownComponent, PdfPreviewComponent, CardSkeletonLoaderComponent, NoDataFoundComponent, TableSkeletonComponent, ButtonComponent,
        HeaderComponent, ChangePasswordFormComponent, ShowpopupDirective, OutsideClickDirective, ShortNamePipe, CustomNumberToWordsPipe, StripHtmlPipe,
        ReplaceUnderscorePipe, EscapeHtmlPipe,
        RemoveDollarSignPipe, TrimDecimalPointsPipe, AppNoSpacesDirective, NoF5DirectiveDirective, CustomDatePipe, LoaderComponent, SafeLinkPipe, AudioVideoPermissionComponent, SuperAdminHeaderComponent, AudioVideoSetupComponent, OtpVerifyBoxComponent
    ], imports: [CommonModule,
        RouterModule,
        WebcamModule,
        DocumentEditorModule,
        NgxSkeletonLoaderModule,
        FormsModule,
        ReactiveFormsModule,
        NgOtpInputModule], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class    SharedModule { }
